import React, { useState } from "react";
import axios from "axios";

const WORK_LOCATIONS = [
  "Ayathi Trust",
  "Direct",
  "Edinborough Products (Pvt) Ltd",
  "Hemas Driver",
  "Hemas FMCG",
  "Hemas MA",
  "Hemas MA-Intern",
  "Hemas MC",
  "Hemas MC-Intern",
  "Hemas SPA",
  "Hemas SPA-Intern",
  "Hemas SR",
  "Hemas SR-Intern",
  "RDB Call Centre",
  "Regional Business Development Manager",
  "Talentfort Franchise Operation",
  "Talentfort Sales Team",
  "Water Board Call Centre",
];

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function SendPayrollMail() {
  const [uploadMonth, setUploadMonth] = useState("");
  const [uploadYear, setUploadYear] = useState(
    new Date().getFullYear().toString(),
  );
  const [workLocations, setWorkLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [result, setResult] = useState(null);

  const handleLocationChange = (location) => {
    setWorkLocations((prev) =>
      prev.includes(location)
        ? prev.filter((item) => item !== location)
        : [...prev, location],
    );
  };

  const handleSelectAll = () => {
    if (workLocations.length === WORK_LOCATIONS.length) {
      setWorkLocations([]);
    } else {
      setWorkLocations(WORK_LOCATIONS);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");
    setErrorMsg("");
    setResult(null);

    try {
      const payload = {
        uploadMonth,
        uploadYear,
        workLocations,
      };

      const res = await axios.post(
        "https://hotfix-back-hris.talentfort.live/send-payslips/mail",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );

      setResponseMsg(res.data.message || "Payslips sent successfully.");
      setResult(res.data);
    } catch (error) {
      setErrorMsg(
        error?.response?.data?.message ||
          error.message ||
          "Failed to send payslips.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h2 style={styles.title}>Send Payroll Emails</h2>

        <form onSubmit={handleSubmit}>
          <div style={styles.row}>
            <div style={styles.field}>
              <label style={styles.label}>Upload Month</label>
              <select
                value={uploadMonth}
                onChange={(e) => setUploadMonth(e.target.value)}
                style={styles.input}
                required
              >
                <option value="">Select Month</option>
                {MONTHS.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Upload Year</label>
              <input
                type="text"
                value={uploadYear}
                onChange={(e) => setUploadYear(e.target.value)}
                placeholder="2026"
                style={styles.input}
                required
              />
            </div>
          </div>

          <div style={styles.field}>
            <div style={styles.locationHeader}>
              <label style={styles.label}>Work Locations</label>
              <button
                type="button"
                onClick={handleSelectAll}
                style={styles.smallBtn}
              >
                {workLocations.length === WORK_LOCATIONS.length
                  ? "Unselect All"
                  : "Select All"}
              </button>
            </div>

            <div style={styles.locationsBox}>
              {WORK_LOCATIONS.map((location) => (
                <label key={location} style={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={workLocations.includes(location)}
                    onChange={() => handleLocationChange(location)}
                  />
                  <span style={{ marginLeft: 8 }}>{location}</span>
                </label>
              ))}
            </div>
          </div>

          <button type="submit" disabled={loading} style={styles.submitBtn}>
            {loading ? "Sending..." : "Send Payroll Emails"}
          </button>
        </form>

        {responseMsg ? (
          <div style={styles.successBox}>
            <p>
              <strong>Success:</strong> {responseMsg}
            </p>
            {result && (
              <div style={{ marginTop: 10 }}>
                <p>Total Records Found: {result.totalRecordsFound ?? 0}</p>
                <p>Total Queued: {result.totalQueued ?? 0}</p>
                <p>Sent Count: {result.sentCount ?? 0}</p>
                <p>Failed Count: {result.failedCount ?? 0}</p>
              </div>
            )}
          </div>
        ) : null}

        {errorMsg ? (
          <div style={styles.errorBox}>
            <p>
              <strong>Error:</strong> {errorMsg}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    padding: "24px",
    background: "#f5f7fb",
    minHeight: "100vh",
  },
  card: {
    maxWidth: "900px",
    margin: "0 auto",
    background: "#fff",
    padding: "24px",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
  },
  title: {
    marginBottom: "20px",
    fontSize: "24px",
    fontWeight: "700",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginBottom: "16px",
  },
  field: {
    marginBottom: "16px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
  },
  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #d0d7e2",
    outline: "none",
    fontSize: "14px",
  },
  locationHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  smallBtn: {
    border: "none",
    padding: "8px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    background: "#e9eefb",
    fontWeight: "600",
  },
  locationsBox: {
    maxHeight: "280px",
    overflowY: "auto",
    border: "1px solid #d0d7e2",
    borderRadius: "10px",
    padding: "12px",
    background: "#fafbfd",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  },
  submitBtn: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "12px",
    cursor: "pointer",
    background: "#253F8D",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    marginTop: "10px",
  },
  successBox: {
    marginTop: "20px",
    padding: "16px",
    borderRadius: "12px",
    background: "#ecfdf3",
    border: "1px solid #b7ebc6",
    color: "#166534",
  },
  errorBox: {
    marginTop: "20px",
    padding: "16px",
    borderRadius: "12px",
    background: "#fef2f2",
    border: "1px solid #fecaca",
    color: "#991b1b",
  },
};
